import get from "lodash/get";

// Expect Contentful rich text -> content -> json
export default function getHeadersFromRichText(json) {
  if (json == null || json.content == null) return [];
  const flatHeaders = json.content
    .filter((c) => ["heading-2", "heading-3"].includes(c.nodeType))
    .map((c) => ({ type: c.nodeType, content: get(c, "content[0].value") }))
    .filter((h) => h.content);
  return nestHeaders(flatHeaders);
}

const nestHeaders = (headers) => {
  const firstH2Index = headers.findIndex((header) => header.type === "heading-2");

  if (firstH2Index === -1) {
    return [];
  }

  let currentH2 = headers[firstH2Index];
  //ignore any h3s before the first h2
  let validHeaders = headers.slice(firstH2Index);

  const returnedHeaders = [];
  for (const header of validHeaders) {
    if (header.type === "heading-2") {
      currentH2 = header;
      returnedHeaders.push(currentH2);
    } else {
      currentH2.children = currentH2?.children !== undefined ? currentH2.children.concat(header) : [header];
    }
  }

  return returnedHeaders;
};
